import React from 'react';
import clsx from 'clsx';

export function Card({ children, className, onClick, ...props }) {
  return (
    <div
      data-portica-role="card"
      className={clsx('card', onClick && 'cursor-pointer', className)}
      onClick={onClick}
      {...props}
    >
      {children}
    </div>
  );
}

export function CardHeader({ children, action, className }) {
  return (
    <div className={clsx('flex items-center justify-between px-6 py-4', className)} style={{ borderBottom: '1px solid var(--color-border)' }}>
      <div className="font-semibold" style={{ color: 'var(--color-text-primary)' }}>{children}</div>
      {action}
    </div>
  );
}

export function CardBody({ children, className }) {
  return (
    <div className={clsx('px-6 py-4', className)}>
      {children}
    </div>
  );
}
